import React, { useEffect, useState } from 'react';
import { api } from '@/lib/api';
import { extractError } from '@/lib/errors';
import { toast } from 'sonner';
import { Dialog, DialogContent, DialogDescription, DialogFooter, DialogHeader, DialogTitle } from '@/components/ui/dialog';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';

export function PurityFormDialog({ open, onOpenChange, companyId, onCreated }) {
  const empty = { name: '', percent: '', description: '' };
  const [form, setForm] = useState(empty);
  const [saving, setSaving] = useState(false);
  useEffect(() => { if (open) setForm(empty); /* eslint-disable-next-line */ }, [open]);

  const submit = async () => {
    if (!form.name.trim() || !form.percent) {
      toast.error('Name and percent are required');
      return;
    }
    setSaving(true);
    try {
      const { data } = await api.post('/gold/purities', {
        name: form.name,
        percent: Number(form.percent),
        description: form.description,
        company_id: companyId,
      });
      toast.success(`Purity "${data.name}" created`);
      onCreated && onCreated(data);
      onOpenChange(false);
    } catch (e) { toast.error(extractError(e, 'Purity create failed')); }
    finally { setSaving(false); }
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-lg max-h-[90vh] overflow-y-auto" data-testid="inline-purity-dialog">
        <DialogHeader>
          <DialogTitle>New Gold Purity</DialogTitle>
          <DialogDescription>Define a karat name and its % gold content for this company.</DialogDescription>
        </DialogHeader>
        <div className="space-y-3">
          <div>
            <Label>Name</Label>
            <Input value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })}
              placeholder="e.g. 22Kt" data-testid="inline-purity-name-input" />
          </div>
          <div>
            <Label>Percent (%)</Label>
            <Input type="number" step="0.01" min="0" max="100" value={form.percent}
              onChange={(e) => setForm({ ...form, percent: e.target.value })}
              placeholder="e.g. 91.60" data-testid="inline-purity-percent-input" />
          </div>
          <div>
            <Label>Description</Label>
            <Input value={form.description}
              onChange={(e) => setForm({ ...form, description: e.target.value })} />
          </div>
        </div>
        <DialogFooter>
          <Button variant="outline" onClick={() => onOpenChange(false)}>Cancel</Button>
          <Button onClick={submit} className="luxury-button" disabled={saving} data-testid="inline-purity-submit-button">{saving ? 'Saving…' : 'Create'}</Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}

export default PurityFormDialog;
